import { useCallback, useEffect, useMemo, useState } from 'react'
import { getEssentialCookie, setEssentialCookie } from 'app/cookiesEvents'
import { applyTheme } from 'app/theme'
// import { prefersDarkMode } from 'app/thread'

// Check local storage for theme
const cookieTheme = getEssentialCookie('theme')
const userPreferredTheme = cookieTheme //  || (prefersDarkMode ? 'dark' : 'light')

/**
 * The `useTheme`
 *
 * @returns {object} the context object
 */
function useTheme () {
  const [theme, setThemeValue] = useState(
    userPreferredTheme === 'light' ? 'light' : 'dark'
  )

  /**
   * On set the theme
   */
  const setTheme = useCallback((nextTheme = 'standard') => {
    const targetTheme = nextTheme === 'light' ? 'light' : 'dark'

    setEssentialCookie('theme', targetTheme)

    setThemeValue(targetTheme)
  }, [])

  /**
   * Effect: When the theme changes
   */
  useEffect(() => {
    applyTheme(theme, document.head)
  }, [theme])

  /**
   * Memo: The context
   */
  const ctx = useMemo(
    () => ({
      theme,
      setTheme
    }),
    [theme, setTheme]
  )

  return ctx
}

// Export
export default useTheme
